//import TodoDailyCDataFunc from "@/pcomponents/common/content/todo/todo_dailyc/data";
import strFunc from '@/lib/lyg/string';

class TodoDailyCDataFunc {
  static default_info={
    a_date:"",
    a_subject:"",
    a_stu_seq:"",
    a_stu_name:"",
    a_writer_seq:"",
    a_writer:"",
    a_sort:"",
    a_star_cnt:"",
    a_teacher_star:"",
    a_memo:"",
  };
  static sort_select_arr=[
    {value:"special",text:"Special"},
    {value:"pass",text:"Pass"},
    {value:"complete",text:"Complete"},
  ];
  static get_info_of_arr(inData:any){
    let opt_obj={
      stu_seq:"",
      select_date:"",
      subject_name:"",
      todo_dailyc_arr:[],
      ...inData
    };
    let todo_dailyc_info={
      ...TodoDailyCDataFunc.default_info,
    };
    let todo_dailyc_arr:any=[];
    if(opt_obj.todo_dailyc_arr){
      todo_dailyc_arr=opt_obj.todo_dailyc_arr;
    }
    let stu_seq=opt_obj.stu_seq;
    let select_date=opt_obj.select_date;
    let subject_name=opt_obj.subject_name;
    if (strFunc.is_empty(subject_name)||strFunc.is_empty(stu_seq)||strFunc.is_empty(select_date)
      ||todo_dailyc_arr.length==0) {
      return todo_dailyc_info;
    }

    for(let i=0;i<todo_dailyc_arr.length;i++){
      let tmp_info=todo_dailyc_arr[i];
      if (tmp_info.a_stu_seq == stu_seq && tmp_info.a_date == select_date && tmp_info.a_subject == subject_name) {
        todo_dailyc_info = tmp_info;
        break;
      }
    }
    return todo_dailyc_info;
  }
}
export default TodoDailyCDataFunc;